import { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'

import CoiffeurService from 'service/CoiffeurService'

// types
interface ICoiffeurPhotoProps {
  coiffeurEmployeeId: number
  IsAbsolute?: boolean
  size?: [number, number]
}

interface IPhotoProps {
  backgroundImageUrl: string
  IsAbsolute: boolean
  size: [number, number]
}

// let chronosAuth = localStorage.getItem('token')
// let webApiKey = localStorage.getItem('webApiKey')

export default function CoiffeurPhoto({ coiffeurEmployeeId, IsAbsolute = true, size = [50, 50] }: ICoiffeurPhotoProps) {
  const [imgUrl, setImgUrl] = useState('')
  useEffect(() => {
    CoiffeurService.getCoiffeurPhoto(coiffeurEmployeeId)
      .then((r) => setImgUrl(`data:image/png;base64, ${r.data}`))
      .catch((error) => console.log(error))
  }, [coiffeurEmployeeId])

  // let backgroundImageUrl = useMemo(
  //   () =>
  //     `${process.env.REACT_APP_API}Employee/GetEmployeePhoto?employeeId=${coiffeurEmployeeId}&ChronosAuth=${chronosAuth}&WebApiKey=${webApiKey}`,
  //   [coiffeurEmployeeId]
  // )

  return <Photo IsAbsolute={IsAbsolute} size={size} backgroundImageUrl={imgUrl} />
}

const Photo = styled.div<IPhotoProps>`
  ${({ IsAbsolute }) =>
    IsAbsolute &&
    css`
      position: absolute;
      top: 40px;
      left: 125px;
      border: 2px solid #fff;
    `}
  background-image: ${({ backgroundImageUrl }) => `url(${backgroundImageUrl})`};
  width: ${({ size }) => `${size[0]}px`};
  height: ${({ size }) => `${size[1]}px`};
  background-size: cover;
  background-position: center center;
  border-radius: 50%;
  border: 1px solid #ccc;
`
